import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CategoryLayout from "@/components/feature/CategoryLayout";
import { categories, posts } from "@/mocks/anime";

const category = categories.find((c) => c.id === "recommend")!;
const list = posts.filter((p) => p.category === "recommend");

export default function Recommend() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryLayout
          category={category}
          posts={list}
          description="把你看番的偏好（热血、治愈、悬疑、恋爱……）说出来，同好帮你把下一部要追的番选出来。求番推荐，来问就有人答。"
        />
      </main>
      <Footer />
    </>
  );
}